import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import {
	ActivatedRouteSnapshot,
	CanActivate,
	Router,
	RouterStateSnapshot,
} from '@angular/router';
import * as Sentry from '@sentry/angular-ivy';
import firebase from 'firebase';
import { Observable } from 'rxjs/internal/Observable';

import { DateTimeService } from './../../services/datetime.service';

@Injectable()
export class AuthGuard implements CanActivate {
	constructor(
		private fbAuth: AngularFireAuth,
		private router: Router,
		private dateTimeService: DateTimeService
	) {}

	private addSentryBreadcrumb(state, passed) {
		Sentry.addBreadcrumb({
			category: 'auth guard - ' + passed,
			data: {
				to: state.url,
			},
			level: 'info',
			type: 'navigation',
			timestamp: new Date().toISOString() as any,
		});
	}

	canActivate(
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		next: ActivatedRouteSnapshot,
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		state: RouterStateSnapshot
	): Observable<boolean> | Promise<boolean> {
		return new Promise((resolve) => {
			this.fbAuth.onAuthStateChanged((user: firebase.User) => {
				const url = window.location.pathname + window.location.search;
				const pathname = window.location.pathname;
				const redirectUrl =
					pathname !== '/logout' && pathname !== '/' ? url : undefined;

				if (user) {
					user.getIdTokenResult().then((idTokenResult) => {
						// if it is a professional reject it
						if (
							!idTokenResult.claims.professional ||
							this.dateTimeService.dateTimeIsBefore(
								idTokenResult.expirationTime
							)
						) {
							this.addSentryBreadcrumb(state, 'denied');
							this.router.navigate(['/logout'], {
								queryParamsHandling: 'merge',
								queryParams: { redirectUrl },
							});
							resolve(false);
						}
						this.addSentryBreadcrumb(state, 'authorized');
						resolve(true);
					});
				} else {
					this.addSentryBreadcrumb(state, 'denied');
					this.router.navigate(['/logout'], {
						queryParamsHandling: 'merge',
						queryParams: { redirectUrl },
					});
					resolve(false);
				}
			});
		});
	}
}
